import service from "../util/service";

/**
 * Call the service to get the article data
 * @param {string} pattern
 */
export function getArticleData(encryptedBlob) {
    return service.post(
        `com.publicrelay.www/prrestservices/client/articledata?blob=${encodeURIComponent(
            encryptedBlob
        )}`,
        encryptedBlob
    );
}

/**
 * call service that will ping Factiva when a PDF is generated
 * @param  {String|Number} articleId
 */
export function pingOnPdfDownload(articleId) {
    return service.get(
        `com.publicrelay.www/prrestservices/client/pingPremiumFeed/${articleId}`
    );
}
